<template>
  <div class="recruitment_container">
    <js-banner
      title="人才招聘"
    />
    <div class="recruitment_wrapper">
      <js-group
        zh="人才招聘"
        en="Join Us"
        :list="group"
        style="flex-shrink: 0;"
      />
      <router-view class="content_container"/>
    </div>
  </div>
</template>

<script>
import JsBanner from '@/packages/JsBanner'
import JsGroup from '@/packages/JsGroup'
export default {
  name: 'trends',
  components: {
    JsBanner,
    JsGroup
  },
  data () {
    return {
      group: [{
        id: Math.random().toString(),
        label: '人才理念',
        path: '/recruitment/policy'
      }, {
        id: Math.random().toString(),
        label: '招聘信息',
        path: '/recruitment/join'
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
.recruitment_wrapper {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  padding: 15px 0;
  .content_container {
    flex-shrink: 1;
    flex-grow: 1;
    margin-left: 30px;
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  }
}
</style>
